export default {
    data() {
        return {
            height: 100
        }
    },

    computed: {
        marginTop() {
            return Math.ceil((this.height - 43) / 2) + 'px'
        },

        marginBottom() {
            return Math.floor((this.height - 43) / 2) + 'px'
        },
        
        loadingSpinnerStyle() {
            return {'margin-top': this.marginTop, 'margin-bottom': this.marginBottom}
        },
        
        heightContainer() {
            return '.panel-body'
        }
    },
    
    methods: {
        saveHeight() {
            if(this.$el.querySelector(this.heightContainer)) {
                this.height = this.$el.querySelector(this.heightContainer).clientHeight
            }
        }
    }
}
